import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { ModalService } from 'src/app/services/modal.service';
import { HotelService } from '../../services/hotel.service';
import { GuestService } from 'src/app/services/guest.service';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { DateUtilityServiceService } from '../../services/date-utility-service.service';
import { VariablesService } from '../../services/variables.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ContactusComponent } from 'src/app/reusable-components/contactus/contactus.component';
import { ConstantsService } from 'src/app/services/constants.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { WSASERVICE_NOT_FOUND } from 'constants';
import { CreditcardService } from 'src/app/services/creditcard.service';
import { LineitemService } from 'src/app/services/lineitem.service';
import { RememberService } from 'src/app/services/remember.service';
import { MatIconModule } from '@angular/material/icon';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  templateUrl: './summary.component.html'
})
export class SummaryComponent implements OnInit {

  isSubmitting = false;
  isError = false;
  hotelsLoaded = false;
  attendee;
  guests;
  enrollment;
  emailAddress;
  hotelList;
  dateRange;
  groupDays;
  preextend;
  postextend;
  hotelStay;
  workAddress: any;
  homeAddress: any;
  workPhone: any;
  homePhone: any;
  mobilePhone: any;
  emerContactMainPhone: any;
  emerContactAltPhone: any;
  adminContact: any;
  hotelSpecialRequests: any;
  hotelSmoking: any;
  personalDisplay: any;
  isRegComplete: any;
  shirtSize;
  shirtSizeValue;
  errorMsg;
  dietaryNeedDisplay;
  personalConsiderationsDisplay;
  mealList;
  personalConsiderationsList;
  pagesInSiteFlow: any;
  page: any;
  firstTime;
  firstTimeValue;
  isFormCompleted;
  whyAttend;
  showpayment = false;
  bestFeature;
  bestFeatureValue;
  bestFeatureFreeForm;
  bestFeatureFreeFormValue;
  bestFeatures;
  bestFeaturesSelections;
  programInfo;
  wealthManFirm;
  successMessage = false;
  ready = false;
  output:any = {
    showGlobals : false,
    config: "",
    enrollment:"",
    programKey:"",
    serviceURL:"",
    hideLimits:true,
    hideHeader:true
  };

  charges = {
    Conference: null,
    Hotel: null,
    Activity: null,
    Guest: null,
    Donation: null,
  };
  payment;
  conferencePayment;
  guaranteecard;
  guaranteePayment;
  cards;
  hotelPayment;
  hotelcard;
  activityPayment;
  activitycard;
  guestPayment;
  guestcard;
  conferencecard;
  rememberme;
  isGDPR;
  antiHarassment;
  photoRelease;
  considerationsAllergies;
  wealthManFirmQualityLevel;
  boardCouncil;
  cfp;
  cfpNumber;
  fieldManager;
  osjName;
  repIdNum;
  langinterp;
  neurdiv;
  ageRange;
  gender;
  jobRole;
  ethnicity;
  numEmployees;
  financialExperience;
  averageAum;
  businessAffiliation;
  altInvestments;
  bufferedProd;
  employerRetirement;
  etfs;
  highWorth;
  models;
  smas;
  aiVehicles;
  smaStrat;
  receiveDigital;
  digitalCredit;
  contactMethod;
  bestDescribes;
  describeBusiness;
  roommateName;
  roommateEmail;
  roommateArrival;
  roommateDeparture;
  beddingPreference;
  donate;
  braindate; 
  department;

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    public modalService: ModalService,
    private hotelService: HotelService,
    private dateService: DateUtilityServiceService,
    private variablesService: VariablesService,
    private guestService: GuestService,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    public Constants: ConstantsService,
    private configurationService: ConfigurationService,
    private creditCardService: CreditcardService,
    private lineItemService: LineitemService,
    private rememberService: RememberService,
    private environmentService: EnvironmentService
  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.guests = this.registrationService.getGuests({});
    this.enrollment = this.registrationService.getEnrollment({});
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});
    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});
    this.adminContact = this.registrationService.getAdminContact({});
    this.hotelSpecialRequests = this.enrollment.HotelSpecialRequests;
    this.hotelSmoking = this.attendee.HotelSmoking;
    this.output.enrollment = this.enrollment;
    this.configurationService.fetchConfig().then( conf =>{
      this.output.config = conf;
      this.output.programKey = this.environmentService.getProgramKey();
      this.output.baseURL = this.environmentService.getEnvironmentUrl("");
      this.output.actEndpoint = "service/webactivity";
      this.ready=true;
      console.log("activity output object ready");
    });

    this.antiHarassment = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSAIC_ANTI_HARASSMENT_POLICY.ID,
      {}
    );

    this.wealthManFirm = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM.ID,
      {}
    );

    this.wealthManFirmQualityLevel = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM_QUALIFICATION_LEVEL.ID,
      {}
    );

    this.boardCouncil = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ADVISE_BOARD_COUNCIL.ID,
      {}
    );

    this.cfp = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.CFP.ID,
      {}
    );


    this.cfpNumber = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.CFP_NUMBER.ID,
      {}
    );

    this.fieldManager = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FIELD_MANAGER.ID,
      {}
    );
    this.osjName = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSJ.ID,
      {}
    );
    this.repIdNum = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.REPID.ID,
      {}
    );

    this.langinterp = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.LANGUAGE_INTERPRETER.ID,
      {}
    );

    this.neurdiv = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.NUERODIVERSITY_CONSIDERATIONA.ID, {}
    );

    this.photoRelease = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSAIC_PHOTO_VIDEO_RELEASE.ID,
      {}
    );

    this.roommateName = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ROOMMATE_NAME.ID,
      {}
    );
    this.beddingPreference = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BEDDING_PREFERENCE.ID,
      {}
    );

    this.firstTime = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FIRST_TIME.ID,
      {}
    );
    this.ageRange = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AGE_RANGE.ID,
      {}
    );
    this.gender = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.GENDER.ID,
      {}
    );
    this.ethnicity = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ETHNICITY.ID,
      {}
    );
    this.jobRole = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BUSINESS_JOB_ROLL.ID,
      {}
    );
    this.numEmployees = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.NUMBER_OF_EMPLOYEES.ID,
      {}
    );
    this.financialExperience = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FINANCIAL_EXPERIENCE.ID,
      {}
    );
    this.averageAum = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AVERAGE_AUM.ID,
      {}
    );
    this.businessAffiliation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BUSINESS_AFFILIATION.ID,
      {}
    );
    this.altInvestments = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_ALTERNATIVE_INVESTMENTS.ID,
      {}
    );
    this.bufferedProd = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_BUFFERED_PRODUCTS.ID,
      {}
    );
    this.employerRetirement = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_EMPLOYER_RETIREMENT_PLANS.ID,
      {}
    );
    this.etfs = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_ETFS.ID,
      {}
    );
    this.highWorth = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_HIGH_NET_WORTH.ID,
      {}
    );
    this.models = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_MODELS.ID,
      {}
    );
    this.smas = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_SMAS.ID,
      {}
    );
    this.aiVehicles = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AI_VEHICLES.ID,
      {}
    );
    this.smaStrat = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.SMA_STRATEGIES.ID,
      {}
    );
    this.receiveDigital = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DC_BREAKOUT_SESSIONS.ID,
      {}
    );
    this.digitalCredit = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DC_CE_CREDITS.ID,
      {}
    );
    this.contactMethod = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.PREFERRED_CONTACT.ID,
      {}
    );

    this.roommateEmail = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ROOMMATE_EMAIL.ID,
      {}
    );

    this.roommateArrival = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ROOMMATE_ARRIVAL.ID,
      {}
    );

    this.roommateDeparture = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ROOMMATE_DEPARTURE.ID,
      {}
    );

    this.donate = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.OSAIC_DONATION.ID,
      {}
    );

    this.braindate = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BRAINDATE_AMBASSADOR.ID,
      {}
    );

    this.department = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DEPARTMENT_NAME.ID,
      {}
    );

    this.bestDescribes = this.ageRange.Value + ', ' + this.gender.Value + ', ' + this.ethnicity.Value;

    this.describeBusiness = this.jobRole.Value + ', ' + this.numEmployees.Value + ', ' + this.financialExperience.Value + ', ' + this.averageAum.Value

    this.cards = this.creditCardService.cards;
    this.lineItemService.getAllLineItems().subscribe(data=>{
      if(data.length>0){
        this.showpayment = true;
      }else{
        this.configurationService.fetchConfig().then((config: any) => {
          if(config.hotelGuarantee && this.registrationService.getEnrollment({}).HotelNeeded == true){
            this.showpayment = true;
          }else if(config.chargeExtensions && this.registrationService.getEnrollment({}).HotelNeeded == true && this.registrationService.getEnrollment({}).$mtcExtension){
            this.showpayment = true;
          }
        });
      }
    });
    this.registrationService.getParticipant([]).forEach(pax=>{
      this.getDisplayName(pax);
    });
    this.payment = this.registrationService.getPayment([]);
    this.guaranteePayment = this.registrationService.getCreditCard(this.payment, "Guarantee", undefined);
    this.conferencePayment = this.registrationService.getCreditCard(this.payment, "Conference", undefined);
    this.conferencecard = this.conferencePayment && this.conferencePayment.MediaType === "CREDITCARD" ? _.filter(this.cards, {"ReferenceKey": this.conferencePayment.ReferenceKey})[0] : undefined;
    this.guaranteecard = this.guaranteePayment && this.guaranteePayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.guaranteePayment.ReferenceKey })[0] : undefined;
    this.hotelPayment = this.registrationService.getCreditCard(this.payment, "Hotel", undefined);
    this.hotelcard = this.hotelPayment && this.hotelPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.hotelPayment.ReferenceKey })[0] : undefined;
    this.activityPayment = this.registrationService.getCreditCard(this.payment, "Activity", undefined);
    this.activitycard = this.activityPayment && this.activityPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.activityPayment.ReferenceKey })[0] : undefined;
    this.guestPayment = this.registrationService.getCreditCard(this.payment, "Guest", undefined);
    this.guestcard = this.guestPayment && this.guestPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.guestPayment.ReferenceKey })[0] : undefined;

    this.isRegComplete = this.registrationService.isRegistrationComplete();
    if(this.attendee.DietaryConsiderations && this.attendee.$mtcAllergens && this.attendee.$mtcAllergens.length > 0){
      console.log(this.attendee.DietaryConsiderations);
      this.considerationsAllergies = this.attendee.$mtcAllergens.join(', ') + ', ' + this.attendee.DietaryConsiderations;
    } else if (this.attendee.DietaryConsiderations){
      this.considerationsAllergies = this.attendee.DietaryConsiderations
    } else if (this.attendee.$mtcAllergens && this.attendee.$mtcAllergens.length > 0) {
      this.considerationsAllergies = this.attendee.$mtcAllergens.join(', ')
    } 

    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;

      if (this.attendee.DietaryNeed) {
        this.dietaryNeedDisplay = _.filter(this.mealList, { "code": this.attendee.DietaryNeed })[0].name;
        if(this.dietaryNeedDisplay == 'Food Allergy' && !this.isRegComplete && !this.attendee.DietaryConsiderations){
          this.dietaryNeedDisplay = this.dietaryNeedDisplay + ' - ' + this.attendee.$mtcAllergens.join(', ')
        }
      }

    });

    if(this.isRegComplete){
      this.attendee.$mtcChosenStrategies = [];
      if ( this.altInvestments.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('Alternative Investments');
      }
  
      if ( this.bufferedProd.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('Buffered Products');
      }
  
      if ( this.employerRetirement.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('Employer Retirement Plans');
      }
  
      if ( this.etfs.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('ETFs');
      }
  
      if ( this.highWorth.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('High Net Worth');
      }
  
      if ( this.models.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('Models');
      }
  
      if ( this.smas.Value == "true" ) {
        this.attendee.$mtcChosenStrategies.push('SMAs');
      }}
    

    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;

      this.personalConsiderationsList.forEach(disability => {
        console.log(disability)
        if(disability.name == "Hearing Impaired"){
          disability.name = "Deaf/Hard of Hearing"
        }
        
      });
    
      if (this.attendee.DisabilityType) {
        var temp;
        var final = "";
        for (var x = 0; x < this.attendee.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": this.attendee.DisabilityType[x] })[0].name;
          if (temp === "Other")
            final = final + temp + " - " + this.attendee.PersonalConsiderations;
          else
            final = final + temp;
          if (this.attendee.DisabilityType.length > 0 && x !== this.attendee.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        this.personalConsiderationsDisplay = final;
      }
    });

    this.listService.getPrivacyPolicyCountryList().then(list => {
      if(!this.enrollment.PrivacyPolicy) {
        this.enrollment.PrivacyPolicy = false;
      }
      this.isGDPR = false;
      for(let country of list) {
        if(country.code === this.attendee.ResidenceCountryISOCode) {
          this.isGDPR = true;
        }
      }
    });

    this.hotelStay = this.registrationService.getHotel([]);
    //check if hotel booking
    this.hotelList = { locked: false };
    if (this.enrollment.HotelNeeded) {
      this.hotelService.getHotelList().then(list => {
        this.hotelList = list;
        if (!this.hotelStay.length) {
          //look for booked stays.
          this.hotelList.roomTypeList.forEach((roomtype) => {
            var groupid = roomtype.webHotelGroupID;
            var pending = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 2 });
            var reserved = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 3 });
            reserved = _.union(pending, reserved);
            reserved.forEach((res) => {
              this.hotelStay.push({ Date: res.blockDate, Hotel: groupid });
            });
          });
        }
        this.hotelsLoaded = true;
      });
    }
  }

  getDisplayName(participant) {
    var returnValue = "";
    this.listService.getPrefixValue(participant.Prefix).then(data=>{
      var prefix = data.name;
      console.log(data);
      console.log(prefix);
      if(prefix){
        returnValue = prefix + " ";
      }
      if (participant.FirstName) {
        returnValue += participant.FirstName + " ";
      }
      if (participant.MiddleName && !participant.NoMiddleNameFlag) {
        returnValue += participant.MiddleName + " ";
      }
      if (participant.LastName) {
        returnValue += participant.LastName + " ";
      }
      this.listService.getSuffixValue(participant.Suffix).then(data=>{
        var suffix = data.name;
        if(suffix && suffix !== "(None)"){
          returnValue += suffix;
        }
        if (returnValue.length <= 1) {
          returnValue = "Personal Information";
        } else {
          returnValue = returnValue.trim();
        }
        participant.$mtcDisplayName = returnValue;
      });
    });

  }


  siteFlowContains(page) {
    let index = 0; let found;
    if (this.pagesInSiteFlow) {
      for (index; index < this.pagesInSiteFlow.length; index++) {
        found = false;

        this.pagesInSiteFlow[index].forEach((entry) => {
          if (entry == '/' + page) {
            found = true;
          }
        });
        if (found) {
          break;
        }
      }
      return found;
    }
  };

  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.navigationService.getNavigationList().then(pagelist => {
        this.pagesInSiteFlow = pagelist;
      });
    });
    if (this.enrollment.$mtcUpdateSuccess) {
      this.successMessage = true;
      this.enrollment.$mtcUpdateSuccess = false;
    }

    for (const key of _.keys(this.charges)) {
      this.lineItemService.getLineItems(key).subscribe({
        next: data => {
          this.charges[key] = _.reduce(data, (sum, n) => {
            return parseFloat(sum) + parseFloat(n);
          });
          },
            error: error => {
              this.Constants.ALERT_POLICY.CONTACT_SUPPORT
            }
      });
    }
  }

  getGuestDiet(guest) {
    if (guest && this.mealList) {
      if (guest.DietaryNeed) {
        let diet = _.filter(this.mealList, { "code": guest.DietaryNeed })[0].name;
        if(diet != 'Food Allergy'){
          return diet
        } else if(!this.isRegComplete) {
          return diet + ' - ' + guest.$mtcAllergens.join(', ')
        } else {
          return diet + '-' + guest.DietaryConsiderations;
        }
      }
    }
  }

  getGuestConsiderations(guest){
    if(guest.DietaryConsiderations && guest.$mtcAllergens){
      return ', ' + guest.DietaryConsiderations;
    }
  }

  getNeuro(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.NUERODIVERSITY_CONSIDERATIONA.ID,
      {}
    ).Value;
  }

  getGuestTypeDisplay(guest) {
    if (guest) {
      return this.guestService.getTypeDisplay(guest);
    }
  }

  getGuestCity(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.GUEST_CITY.ID,
      {}
    ).Value;
  }

  getGuestState(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.GUEST_STATE.ID,
      {}
    ).Value;

  }

  getGuestLang(guest){
    return this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.LANGUAGE_INTERPRETER.ID,
      {}
    ).Value
  }



  getGuestADAPersonal(guest) {
    if (guest && this.personalConsiderationsList) {
      if (guest.DisabilityType) {
        var temp;
        var final = "";
        for (var x = 0; x < guest.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": guest.DisabilityType[x] })[0].name;
          if (temp === "Other")
            final = final + temp + " - " + guest.PersonalConsiderations;
          else
            final = final + temp;
          if (guest.DisabilityType.length > 0 && x !== guest.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        return final;
      }
    }
  }

  printPage() {
    window.print();
  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  getHotelsWithStays() {
    var hotelids = _.uniq(_.map(this.hotelStay, "Hotel"));
    var hotels = [];
    if (this.hotelList) {
      var self = this;
      hotelids.forEach((id)=> {
        var hotel = _.filter(self.hotelList.roomTypeList, { webHotelGroupID: id })[0];
        var hotelNights = self.getNightsAtHotel(hotel.webHotelGroupID);
        hotel.firstNight = hotelNights[0];
        hotels.push(hotel);
      });
    }
    return hotels;
  };

  getNightsAtHotel(hotelid) {
    this.hotelStay.forEach( (hotelnight) =>{
      if (moment.isMoment(hotelnight.Date)) {
        hotelnight.Date = hotelnight.Date.toDate();
      }
    });
    return _.orderBy((_.map(_.filter(this.hotelStay, { Hotel: hotelid }), "Date")));
  };

  getStatus(hotelobj, date) {
    var hotelnight;
    var testDate;

    if (moment.isMoment(date)) {
      testDate = date.toDate();
    } else {
      testDate = this.dateService.createMTCZoneDateTime(date).toDate();
    }
    var self = this;
    _.forEach(hotelobj.roomNightsListWithRate, (night) => {
      var nightDate = self.dateService.createMTCZoneDateTime(night.blockDate).toDate();
      var inputDate = testDate;
      if (nightDate.getTime() === inputDate.getTime()) {
        hotelnight = night;
      }
    });

    if (hotelnight.availabilityCode === 1) {
      //if night is not already booked.
      if (hotelnight.groupDateFlag === "GRP") {
        return "Confirmed";
      } else {
        return "Pending";
      }
    } else if (hotelnight.availabilityCode === 2) {
      return "Pending";
    } else if (hotelnight.availabilityCode === 3) {
      return "Confirmed";
    }
  };

  editAttendee() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    } else {
      this.router.navigate(['attendee']);}
  }
  editGuest(guest) {
    if (guest) {
      this.guestService.selectGuest(guest);
    }
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    } else{
      this.router.navigate(['guest']);}
  }
  editDemographics() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    } else{
      this.router.navigate(['demographics']);
    }
  }
  editHotel() {
    if (this.hotelList.locked || this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      if (this.programInfo) {
        if (this.programInfo.hotelpackage) {
          this.router.navigate(['hotelpackage']);
        } else if (this.programInfo.hotelBooking) {
          this.router.navigate(['hotelbooking']);
        } else {
          this.router.navigate(['hotel']);
        }
      }
    }
  }
  editTravel() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.router.navigate(['travel']);
    }
  }
  editGuestTravel(guest) {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.guestService.selectGuest(guest);
      this.router.navigate(['guest-travel']);
    }
  }
  editSessions() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.router.navigate(['activity']);
    }
  }

  /**
  * @function editPayment
  * @description Sets activity path to payment page.
  */
  editPayment() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    } else{
      this.router.navigate(['payment']);
    }
    
  }

  setGuestDietary(){
    this.guests.forEach((guest) => {
      if(guest.DietaryConsiderations && guest.$mtcAllergens){
        guest.DietaryConsiderations = guest.$mtcAllergens.join(', ') + ', ' + guest.DietaryConsiderations;
      } else if (guest.$mtcAllergens) {
        guest.DietaryConsiderations = guest.$mtcAllergens.join(', ')
      }
    })
  }



  forward(form) {
    if (!this.isSubmitting) {
    this.isFormCompleted = true;
    this.isSubmitting = true;
    this.errorMsg = undefined;
    /* if () { */
    if (form.valid ) {
      this.attendee.DietaryConsiderations = this.considerationsAllergies;
      this.setGuestDietary();
      if(this.enrollment.HotelSpecialRequests && this.beddingPreference.Value){
        this.enrollment.HotelSpecialRequests = this.enrollment.HotelSpecialRequests + ' - ' + this.beddingPreference.Value
      } else if(this.beddingPreference.Value) {
        this.enrollment.HotelSpecialRequests = this.beddingPreference.Value;
      }
      if (this.enrollment.AgreedToTermsAndConditions) {
        this.enrollment.ResponsibilityStatement = true;
      }
      if (this.attendee.TravelType === undefined) {
        this.attendee.TravelType = 'UNK';
      }
      if (this.antiHarassment.Value){
        this.antiHarassment.Value = "Agreed";
      }
      if (this.photoRelease.Value){
        this.photoRelease.Value = "Agreed";
      }
      this.enrollmentService.createEnrollment(this.registrationService.getEnrollment({})).then(() => {
        if(this.rememberme){
          this.rememberService.setCookie(this.registrationService.getEnrollment({}).$mtcConfirmationCode, this.emailAddress.EmailAddress);
        }
        this.router.navigate(['acknowledgement']);
      }, (err) => {
        this.isSubmitting = false;

        this.errorMsg = "Error while submitting your registration.";
      });
      //this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;
    }
    //this.navigationService.forward();
    /* } else {
      this.isError = true;
      this.isSubmitting = false;
    } */
    }
  }


}
